export default __webpack_public_path__ + "static/media/icon-twitter.09516173.svg";